var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        {
          staticClass: "card",
          attrs: {
            to: _vm.disabled || _vm.redirect === true ? undefined : _vm.route,
            ripple: "",
            raised: "",
            disabled: _vm.disabled || _vm.inactive,
            hover: !_vm.disabled,
            height: "100%",
            "tk-id": _vm.trackingIdentifier
          },
          on: { click: _vm.redirectToOutSide }
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "hub-item-outer-container",
              class: { disabled: _vm.disabled },
              attrs: { column: "", "fill-height": "" }
            },
            [
              _c(
                "div",
                { staticClass: "hub-item-text-container scroll-fire-fox" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "hub-item-title",
                      style: { "font-size": _vm.titleFontSize }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "hub-item-description" }, [
                    _vm._v("\n        " + _vm._s(_vm.description) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _vm.dev && _vm.isSuperAdmin
                    ? _c("dev-tag", {
                        staticStyle: {
                          "border-radius": "8px",
                          margin: "15px 0",
                          background: "var(--primary-highlight)",
                          color: "white"
                        },
                        attrs: { position: "relative" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10b60524", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b60524","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hub/HubItem.vue
// module id = null
// module chunks = 